import { render, staticRenderFns } from "./IslandModal.vue?vue&type=template&id=75c18f02&"
import script from "./IslandModal.vue?vue&type=script&lang=js&"
export * from "./IslandModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports